<template>
  <VuePerfectScrollbar class="bbe-font-family" v-click-outside="close" v-if="!hide">
    <div class="bbe-font-family__item" :style="{ fontFamily: font.title}"
         v-for="(font,index) in fontFamilies"
         @click="setFont(font)"
         :key="font.title + index">
      {{font.title}}
    </div>
  </VuePerfectScrollbar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import fontFamilies from '@/constants/toolbarEditorOptions/fontFamilies'

export default {
  name: 'FontFamilySelect',
  components: {VuePerfectScrollbar},
  data () {
    return {
      hide: false,
      fontFamilies: fontFamilies
    }
  },
  methods: {
    setFont (font) {
      this.hide = true
      this.$emit('set', font)
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbe-font-family {
    display: flex;
    flex-direction: column;
    background-color: $color-white;
    padding: 6px 0;
    width: 100%;
    height: 200px;

    &__item {
      text-align: left;
      width: 100%;
      padding: 6px 12px;
      font-size: 13px;
      transition: 0.3s;

      &:hover {
        background-color: $color-gallery;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/TextEditor/FontFamilySelect/FontFamilySelect.vue